const generateUUID = () => {
	function ff(s) {
		var pt = (Math.random().toString(16) + "000000000").substring(2, 10);
		return s ? "-" + pt.substring(0, 4) + "-" + pt.substring(4, 8) : pt;
	}
	return ff() + ff(true) + ff(true) + ff();
};

export { generateUUID };
